import SUPPORTED_DATE_TYPES from './SUPPORTED_DATE_TYPES';

/**
 * date string formatter based on the current locale.
 * @param {String} date
 * @param {String} locale //Example: en_US
 * @param {String} type //one of SUPPORTED_DATE_TYPES
 * @param {boolean} utc //show UTC time
 * */
export const dateFormat = ({ date, locale, type, utc }) => {
  // only render if a date is provided and has browser window object to handle user timezone
  if (!date || !Date) return null;

  const localeString = locale.replace('_', '-');
  const dateObj = new Date(date);

  // utc option is used when input is a Time Stamp
  const utcObj = utc ? { timeZone: 'UTC' } : {};

  const month = dateObj.toLocaleString(localeString, {
    month: 'short',
    ...utcObj,
  });
  const day = dateObj.toLocaleString(localeString, {
    day: '2-digit',
    ...utcObj,
  });
  const year = dateObj.toLocaleString(localeString, {
    year: 'numeric',
    ...utcObj,
  });
  const dateString = `${day}-${month}-${year}`;
  const timeString = dateObj.toLocaleTimeString(localeString, {
    hour: '2-digit',
    minute: '2-digit',
    ...utcObj,
  });

  switch (type) {
    case SUPPORTED_DATE_TYPES[1]:
      // display time
      return timeString;
    case SUPPORTED_DATE_TYPES[2]:
      // display date and time
      return `${dateString} ${timeString}`;
    default:
      // display date
      return dateString;
  }
};
